import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAttributesbyid } from "src/api/common";
import {
  handleTransactionNoChange,
  getCustomerPaymentPublic,
  createCustomerDraftFromLink,
  processReceiptWithAI,
  generateEInvoice,
} from "src/api/commonapi";
import PaymentReceiptUpload from "src/views/CommonFunctions/PaymentReceiptUpload";
import { Routes } from "src/constants/api_url";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CSpinner,
  CModal,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import { cilArrowRight } from "@coreui/icons";
import Select from "react-select";
import parse from "html-react-parser";
import CustomImage from "src/views/CommonFunctions/CustomImage";
import cross from "../Customer/cross.jpg";
import moment from "moment";
import "../Customer/extraDocument.scss";
import CIcon from "@coreui/icons-react";

function CustomerPaymentPublic() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [modes, setModes] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [aiOcrLoading, setAiOcrLoading] = useState(false);

  const [formData, setFormData] = useState({
    payment_date: moment().format("DD-MM-YYYY"),
    net_amt: "",
    paid_amt: "",
    due_amt: "",
    totalDraft: 0,
    tdsAmount: 0,
    advance_payable_amount: "",
    advance_paid: 0,
    advance_due_amt: 0,
    advance_paid_status: 0,
    mode_id: 165,
    receive_amt: "",
    bank_name: "",
    chk_dd_no: "",
    chk_dd_date: moment().format("DD-MM-YYYY"),
  });
  // const [receiptUploaded, setReceiptUploaded] = useState(false);

  const [receiptFile, setReceiptFile] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState(null);
  const [receiptPreviewType, setReceiptPreviewType] = useState(null);
  const [receiptInvalid, setReceiptInvalid] = useState(false);
  const [receiptUploadKey, setReceiptUploadKey] = useState(0);
  const [txWarning, setTxWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");
  const [openPopup, setOpenPopup] = useState({ op: false });

  useEffect(() => {
    fetchData();
    fetchModes();
  }, []);

  const fetchModes = async () => {
    try {
      let modeData = await fetchAttributesbyid(15);
      let newmode = [];
      modeData &&
        modeData?.map((res) => {
          if (res.attribute_id == 165) {
            newmode.push({ value: res.attribute_id, label: res.name });
          }
        });
      setModes(newmode);
    } catch (err) {
      console.error("Failed to fetch modes", err);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getCustomerPaymentPublic(id);
      if (result.status === 1) {
        setCustomerData(result.data.customer);
        setPaymentData(result.data);
        setFormData((prev) => ({
          ...prev,
          net_amt: result.data.net_amt || "",
          paid_amt: result.data.paid_amt || "",
          due_amt:
            parseFloat(result.data.due_amt || 0) -
            parseFloat(result.data.totalDraft || 0),
          totalDraft: result.data.totalDraft || 0,
          tdsAmount: result.data.tdsAmount || 0,
          advance_payable_amount: result.data.advance_payable_amount || "",
          advance_paid: result.data.advance_paid || 0,
          advance_due_amt: result.data.advance_due_amt || 0,
          advance_paid_status: result.data.advance_paid_status || 0,
          mode_id: 165,
        }));
      } else {
        setErrorModalMessage(result.message || "Invalid payment link");
        setErrorMsg(result.message || "Invalid payment link");
      }
    } catch (err) {
      setErrorMsg("Failed to load payment data");
    }
    setLoading(false);
  };

  const handleFileSelect = async (file) => {
    if (file?.remove) {
      setReceiptFile(null);
      setReceiptPreview(null);
      setReceiptPreviewType(null);
      setReceiptInvalid(false);
      return;
    }
    setReceiptFile(file);
    setReceiptInvalid(false);
    if (file.type === "application/pdf") {
      setReceiptPreview(URL.createObjectURL(file));
      setReceiptPreviewType("pdf");
    } else {
      setReceiptPreview(URL.createObjectURL(file));
      setReceiptPreviewType("image");
    }
    // setReceiptUploaded(true);
    setAiOcrLoading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const ocrResult = await processReceiptWithAI(form);
      if (ocrResult?.status === 0 && /payment not received/i.test(ocrResult?.message || "")) {
        setReceiptFile(null);
        setReceiptPreview(null);
        setReceiptPreviewType(null);
        setReceiptInvalid(true);
        setReceiptUploadKey((k) => k + 1);
        setErrorModalMessage(ocrResult.message);
        setShowErrorModal(true);
        setAiOcrLoading(false);
        return;
      }
      if (ocrResult.status === 1 && ocrResult.data) {
        const d = ocrResult.data;
        const updates = {};
        if (d.amount) updates.receive_amt = d.amount;
        if (d.bank_name) updates.bank_name = d.bank_name;
        const cleanVal = (v) =>
          v && v !== "null" && v !== "undefined" && !String(v).includes("@")
            ? v
            : null;
        const ocrTxnId =
          cleanVal(d.utr) ||
          cleanVal(d.transaction_id) ||
          cleanVal(d.reference_number);
        if (ocrTxnId) {
          updates.chk_dd_no = ocrTxnId;
          let isExist = await handleTransactionNoChange(updates.chk_dd_no);
          if (isExist?.data === true) {
            setTxWarning(true);
            setShowPopup(true);
          } else {
            setTxWarning(false);
          }
        }
        setFormData((prev) => ({ ...prev, ...updates }));
      }
    } catch (err) {
      console.error("OCR failed", err);
    }
    setAiOcrLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (receiptInvalid) {
      setErrorModalMessage("Payment not received. Please contact us");
      setShowErrorModal(true);
      return;
    }
    if (!receiptFile) {
      setErrorModalMessage("Please upload a payment receipt/screenshot");
      setShowErrorModal(true);
      return;
    }
    if (!formData.receive_amt) {
      setErrorModalMessage("Receive amount is required");
      setShowErrorModal(true);
      return;
    }
    let dueAmt = parseFloat(formData.due_amt || 0);
    if (parseFloat(formData.receive_amt) > dueAmt) {
      setErrorModalMessage("Receive amount cannot exceed due amount");
      setShowErrorModal(true);
      return;
    }
    // if (formData.mode_id != 160 && formData.mode_id != 167) {
    //   if (!formData.bank_name) {
    //     setErrorModalMessage("Bank name is required");
    //     setShowErrorModal(true);
    //     return;
    //   }
    // }
    if (!formData.chk_dd_no) {
      setErrorModalMessage(
        "The transaction number is missing from the payment screenshot provided. Please upload an updated screenshot that includes the transaction number",
      );
      setShowErrorModal(true);
      return;
    }
    let isExist = await handleTransactionNoChange(formData.chk_dd_no);
    if (isExist?.data === true) {
      setTxWarning(true);
      setShowPopup(true);
      return;
    }
    setSubmitting(true);
    try {
      const submitForm = new FormData();
      submitForm.append("tracking_id", id);
      submitForm.append("payment_date", formData.payment_date);
      submitForm.append("mode_id", formData.mode_id);
      submitForm.append("receive_amt", formData.receive_amt);
      submitForm.append("bank_name", formData.bank_name);
      submitForm.append("chk_dd_no", formData.chk_dd_no);
      submitForm.append("chk_dd_date", formData.chk_dd_date);
      submitForm.append("receiptFile", receiptFile);

      const result = await createCustomerDraftFromLink(submitForm);
      if (result.status === 1) {
        let advance =
          paymentData?.send_advance == 2 ||
          parseFloat(paymentData?.net_amt || 0) <=
            parseFloat(paymentData?.advance_payable_amount || 0)
            ? parseFloat(paymentData?.net_amt || 0) -
              parseFloat(paymentData?.tdsAmount || 0)
            : parseFloat(paymentData?.advance_payable_amount || 0) -
              parseFloat(paymentData?.tdsAmount || 0);
        if (
          advance >
          parseFloat(paymentData?.paid_amt || 0) +
            parseFloat(formData.receive_amt || 0) +
            parseFloat(paymentData?.totalDraft || 0)
        ) {
          setOpenPopup({ op: true });
        } else if (
          customerData?.is_embassy_invoice == 0 &&
          parseFloat(paymentData?.embassy_fees || 0) > 0 &&
          customerData?.c_tax == 0 &&
          !paymentData?.embassy_invoice_blocked &&
          formData.mode_id != 160
        ) {
          let gType =
            (paymentData?.payment?.c_state || paymentData?.c_state) ==
            paymentData?.branchData?.state_id
              ? 0
              : 1;
          await generateEInvoice({
            c_id: paymentData?.payment?.c_id,
            g_type: gType,
            embassy_fees: paymentData?.embassy_fees || 0,
          });
          if (
            paymentData?.status_id == 22 &&
            paymentData?.dispatching_doc_url
          ) {
            navigate(paymentData?.dispatching_doc_url, { replace: true });
            // window.history.replaceState(
            //   null,
            //   "",
            //   paymentData?.dispatching_doc_url,
            // );
          } else {
            navigate(`/lead-payment/thankyou`);
          }
        } else {
          if (
            paymentData?.status_id == 22 &&
            paymentData?.dispatching_doc_url
          ) {
            navigate(paymentData?.dispatching_doc_url, { replace: true });
            // window.history.replaceState(
            //   null,
            //   "",
            //   paymentData?.dispatching_doc_url,
            // );
          } else {
            navigate(`/lead-payment/thankyou`);
          }
        }
      } else {
        setErrorModalMessage(result.message || "Failed to submit payment");
        setShowErrorModal(true);
      }
    } catch (err) {
      setErrorModalMessage("Failed to submit payment");
      setShowErrorModal(true);
    }
    setSubmitting(false);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <CSpinner />
      </div>
    );
  }

  if (errorMsg && !customerData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <CCard style={{ width: "500px" }}>
          <CCardBody className="text-center p-5">
            <h4 className="text-danger mb-3">
              {errorModalMessage || errorMsg}
            </h4>
          </CCardBody>
        </CCard>
      </div>
    );
  }

  if (paymentData?.fully_paid == 1) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", background: "#f5f7fa" }}
      >
        <CCard style={{ width: "500px" }}>
          <CCardBody className="text-center p-5">
            <div style={{ fontSize: 64, marginBottom: 16 }}>✓</div>
            <h3 className="mb-3">No Due Amount</h3>
            <p className="text-muted mb-0">
              Your payment transaction details have been received successfully
            </p>
          </CCardBody>
        </CCard>
      </div>
    );
  }

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", background: "#f5f7fa", padding: "20px" }}
      >
        <CCard style={{ width: "950px" }}>
          <CCardHeader className="text-center">
            {paymentData?.branchData && (
              <div className="mb-2">
                <CustomImage
                  src={`${Routes.API_HOSTNAME}/images/branchlogo/${paymentData.branchData.logo}`}
                  width="100px"
                  height="100px"
                  style={{ objectFit: "contain" }}
                />
                <h4 className="mb-0" style={{ margin: "8px 0" }}>
                  {customerData?.c_tax == 1
                    ? paymentData.branchData.company_name
                    : paymentData.branchData.ng_company_name}
                </h4>
              </div>
            )}
            <h5
              className="mb-0"
              style={{
                color: "#003366",
                fontWeight: "bold",
              }}
            >
              Follow the Steps
            </h5>
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-1">
              <span>
                1. Make the Payment{" "}
                <CIcon
                  icon={cilArrowRight}
                  className="d-none d-md-inline-block"
                />{" "}
              </span>
              <span>
                2. Upload payment screenshot{" "}
                <CIcon
                  icon={cilArrowRight}
                  className="d-none d-md-inline-block"
                />{" "}
              </span>
              <span>3. Submit</span>
            </div>
            {customerData && (
              <small className="text-muted">
                {customerData.c_prefix} {customerData.c_name} -{" "}
                {customerData.co_no}
              </small>
            )}
          </CCardHeader>
          <CCardBody>
            <CForm onSubmit={handleSubmit}>
              <CRow>
                <CCol md={6} className="border-start mb-2">
                  <div
                    style={{
                      background: "#bde3c6",
                      padding: "8px 12px",
                      fontWeight: "bold",
                      // borderRadius: 4,
                      marginBottom: 12,
                    }}
                  >
                    Step - 1
                  </div>
                  <>
                    {receiptPreview ? (
                      <div>
                        {/* <CFormLabel className="col-sm-4 col-form-label">
                          Uploaded Receipt:
                        </CFormLabel> */}
                        {receiptPreviewType === "pdf" ? (
                          <iframe
                            src={receiptPreview}
                            title="Receipt Preview"
                            style={{
                              width: "100%",
                              height: 500,
                              border: "1px solid #ddd",
                              borderRadius: 4,
                            }}
                          />
                        ) : (
                          <img
                            src={receiptPreview}
                            alt="Receipt Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 500,
                              objectFit: "contain",
                              border: "1px solid #ddd",
                              borderRadius: 4,
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      paymentData?.bankDetail && (
                        <>
                          <CFormLabel
                            style={{ color: "#003366", fontWeight: "bold" }}
                          >
                            Make the payment using the details below
                          </CFormLabel>
                          <div className="bank-detail-content">
                            {parse(
                              (paymentData.bankDetail || "").replace(
                                /<p[^>]*>\s*(?:&nbsp;|\u00a0)?\s*<\/p>/gi,
                                "",
                              ),
                            )}
                          </div>
                        </>
                      )
                    )}
                  </>
                  {aiOcrLoading && (
                    <div
                      className="ai-ocr-loading p-2 mb-2 mt-2"
                      style={{ fontSize: 13 }}
                    >
                      <CSpinner size="sm" /> Extracting data from receipt...
                    </div>
                  )}
                </CCol>
                <CCol md={6}>
                  <div
                    style={{
                      background: "#bde3c6",
                      padding: "8px 12px",
                      fontWeight: "bold",
                      // borderRadius: 4,
                      marginBottom: 12,
                    }}
                  >
                    Step - 2
                  </div>
                  <PaymentReceiptUpload
                    key={receiptUploadKey}
                    onFileChange={handleFileSelect}
                    hidePreview
                  />
                  <CRow className="mb-2 mt-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Date
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.payment_date}
                        disabled
                      />
                    </div>
                  </CRow>
                  {/* <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Net Amount
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.net_amt}
                        disabled
                      />
                    </div>
                  </CRow> */}
                  {formData.advance_paid_status == 1 ? (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Advance Due Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.advance_due_amt || 0}
                          disabled
                        />
                      </div>
                    </CRow>
                  ) : formData.advance_paid_status != 2 ? (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Advance Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.advance_payable_amount}
                          disabled
                        />
                      </div>
                    </CRow>
                  ) : null}
                  {/* <CRow className="mb-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Payment Mode
                    </CFormLabel>
                    <div className="col-sm-8">
                      <Select
                        value={modes?.map((u) => {
                          if (u.value == formData.mode_id) {
                            return { value: u.value, label: u.label };
                          } else return null;
                        })}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            mode_id: e.value,
                          }));
                        }}
                        options={modes}
                        isDisabled
                      />
                    </div>
                  </CRow> */}
                  <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      {/* Paid Amount */}
                      Previously Paid
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.paid_amt || 0}
                        disabled
                      />
                    </div>
                  </CRow>
                  {formData.advance_paid_status == 2 && (
                    <CRow className="mb-1">
                      <CFormLabel className="col-sm-4 col-form-label">
                        Due Amount
                      </CFormLabel>
                      <div className="col-sm-8">
                        <CFormInput
                          type="text"
                          value={formData.due_amt}
                          disabled
                        />
                      </div>
                    </CRow>
                  )}
                  <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      {/* Total Draft */}
                      Currently Paid
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.totalDraft}
                        disabled
                      />
                    </div>
                  </CRow>
                  {/* <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Total TDS
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.tdsAmount}
                        disabled
                      />
                    </div>
                  </CRow> */}
                  <CRow className="mb-2">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Receive
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.receive_amt}
                        disabled
                        placeholder="Auto-filled from receipt"
                      />
                    </div>
                  </CRow>
                  {formData.mode_id != 160 && formData.mode_id != 167 && (
                    <>
                      <CRow className="mb-2">
                        <CFormLabel className="col-sm-4 col-form-label">
                          Bank Name
                        </CFormLabel>
                        <div className="col-sm-8">
                          <CFormInput
                            type="text"
                            value={formData.bank_name}
                            disabled
                            placeholder="Auto-filled from receipt"
                          />
                        </div>
                      </CRow>
                      <CRow className="mb-2">
                        <CFormLabel className="col-sm-4 col-form-label">
                          {/* DD/Cheque No */}
                          UTR/Transaction Ref. number
                        </CFormLabel>
                        <div className="col-sm-8">
                          <CFormInput
                            type="text"
                            value={formData.chk_dd_no}
                            disabled
                            placeholder="Auto-filled from receipt"
                          />
                        </div>
                      </CRow>
                      {/* <CRow className="mb-2">
                        <CFormLabel className="col-sm-4 col-form-label">
                          DD/Cheque Date
                          Payment Date
                        </CFormLabel>
                        <div className="col-sm-8">
                          <CFormInput
                            type="date"
                            value={
                              formData.chk_dd_date == undefined ||
                              formData.chk_dd_date == ""
                                ? moment().format("YYYY-MM-DD")
                                : moment(
                                    formData.chk_dd_date,
                                    "DD-MM-YYYY",
                                  ).format("YYYY-MM-DD")
                            }
                            disabled
                          />
                        </div>
                      </CRow> */}
                    </>
                  )}
                  {/* <CRow className="mb-1">
                    <CFormLabel className="col-sm-4 col-form-label">
                      Total Advanced Payable Amount
                    </CFormLabel>
                    <div className="col-sm-8">
                      <CFormInput
                        type="text"
                        value={formData.advance_payable_amount}
                        disabled
                      />
                    </div>
                  </CRow> */}
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <div
                        style={{
                          background: "#bde3c6",
                          fontWeight: "bold",
                          padding: "10px 12px",
                          width: "100%",
                        }}
                      >
                        Step - 3
                      </div>
                    </div>
                    <div className="col-sm-8 text-center">
                      <CButton
                        type="submit"
                        color="dark"
                        disabled={submitting || aiOcrLoading || receiptInvalid}
                        style={{ padding: "8px 40px" }}
                      >
                        {submitting ? (
                          <>
                            <CSpinner size="sm" /> Submitting...
                          </>
                        ) : (
                          "Submit Payment"
                        )}
                      </CButton>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </div>
      {aiOcrLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="text-center p-4"
            style={{
              background: "#fff",
              borderRadius: 8,
              minWidth: 250,
            }}
          >
            <CSpinner size="lg" />
            <p className="mt-2 mb-0">Extracting data from receipt...</p>
          </div>
        </div>
      )}
      {showPopup && (
        <CModal backdrop="static" alignment="center" visible={true}>
          <CModalBody>
            <CustomImage src={cross} className="cross_img" />
            <h5 className="d-flex justify-content-center">
              <b className="px-2">{formData.chk_dd_no}</b> Transaction Number
              Already Exists
            </h5>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowPopup(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      )}
      {showErrorModal && (
        <CModal backdrop="static" alignment="center" visible={true}>
          <CModalBody>
            <CustomImage src={cross} className="cross_img" />
            <h5 className="d-flex justify-content-center text-center text-danger">
              {errorModalMessage}
            </h5>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowErrorModal(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      )}
      {openPopup?.op && (
        <CModal backdrop="static" alignment="center" visible={true}>
          <CModalBody>
            <CustomImage src={cross} className="cross_img" />
            <div>
              <h5 className="d-flex justify-content-center">
                Still Process is Hold
              </h5>
              <h6 className="d-flex justify-content-center">
                So Process Remaining Advanced Payment
              </h6>
            </div>
          </CModalBody>
          <CModalFooter className="d-flex justify-content-between">
            <CButton
              color="primary"
              onClick={() => {
                setOpenPopup({ op: false });
                window.location.reload();
              }}
            >
              Click here to pay remain advance amount
            </CButton>
            <CButton
              color="secondary"
              onClick={() => {
                setOpenPopup({ op: false });
                navigate(`/lead-payment/thankyou`);
              }}
            >
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  );
}

export default CustomerPaymentPublic;
